import { round, Tranche } from "@lib/tranche";

export function normalizeTrancheList(trancheList: Tranche[]): Tranche[] {
  const totalTrancheHeight = trancheList.reduce(
    (acc, tranche) => acc + tranche.height,
    0,
  );

  // Rescale tranche heights so they sum to 1.0, rounded to 3 places
  const rescaledTrancheList = trancheList.map((tranche) => ({
    ...tranche,
    height: round(tranche.height / totalTrancheHeight, 3),
  }));

  // TODO: Figure out how far off from summing to 1.0 we are, as a result of the rounding, and distribute the difference (in increments of .001) between tranches.
  return rescaledTrancheList;
}
